import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CallbackTriggers, UserActionType } from 'types';

export type CallbackTriggersState = {
  callbackTriggers: CallbackTriggers;
};

const initialState: CallbackTriggersState = {
  callbackTriggers: []
};

export const callbackTriggersSlice = createSlice({
  name: 'callbackTriggers',
  initialState,
  reducers: {
    set: (state, action: PayloadAction<CallbackTriggers>) => ({
      callbackTriggers: action.payload
    }),
    add: (state, action: PayloadAction<CallbackTriggers>) => ({
      callbackTriggers: [...state.callbackTriggers, ...action.payload]
    }),
    remove: (state, action: PayloadAction<UserActionType>) => ({
      callbackTriggers: state.callbackTriggers.filter(trigger => trigger.type !== action.payload)
    }),
    reset: () => initialState
  }
});

export const callbackTriggersReducer = callbackTriggersSlice.reducer;
export const callbackTriggersActions = {
  ...callbackTriggersSlice.actions
};
